import { useEffect, useState } from "react";
import { getResponseToState } from "../mappers/getPaymentProviderMapper";
import { useFetch } from "@common/hook/useFetch";
import { IPaymentProviderResponse, TIsNewPaymentProvider } from "@features/Payment/interface/IPaymentProvider";
import { getPaymentProviderApiRoute } from "@api-routes/elavonFacade";

export const useGetPaymentProvider = (accountId?: string) => {
    const [isNewPaymentProvider, setIsNewPaymentProvider] = useState<TIsNewPaymentProvider>();
    const [paymentProviderState, { get }] = useFetch();

    useEffect(() => {
        if (accountId) {
            get<IPaymentProviderResponse>(getPaymentProviderApiRoute(accountId)).then((paymentProviderResponse) => {
                if (paymentProviderResponse) {
                    setIsNewPaymentProvider(getResponseToState(paymentProviderResponse));
                }
            });
        }
    }, [accountId, get]);

    return { isNewPaymentProvider, paymentProviderState };
};
